/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-pixi-exports.mjs
 * Source: pixi.js@8.19.0 (dist/pixi.mjs ESM bundle)
 * Generated at: 2026-09-12T03:19:54.458Z
 */

export const EMBEDDED_PIXI_819_VERSION = "8.19.0" as const;

export const EMBEDDED_PIXI_819_NAMED_EXPORTS = [
  "AbstractBitmapFont",
  "AbstractBitmapTextPipe",
  "AbstractRenderer",
  "AbstractSplitText",
  "AbstractText",
  "AbstractTextSystem",
  "AccessibilitySystem",
  "accessibilityTarget",
  "addBits",
  "addMaskBounds",
  "addMaskLocalBounds",
  "addProgramDefines",
  "AlphaFilter",
  "alphaFrag",
  "AlphaMask",
  "AlphaMaskPipe",
  "alphaWgsl",
  "AnimatedSprite",
  "appendSVGPath",
  "Application",
  "ApplicationInitHook",
  "applyMatrix",
  "applyProjectiveTransformationToPlane",
  "applyStyleParams",
  "Assets",
  "AssetsClass",
  "assignWithIgnore",
  "autoDetectEnvironment",
  "autoDetectRenderer",
  "autoDetectSource",
  "BackgroundLoader",
  "BackgroundSystem",
  "basisTranscoderUrls",
  "Batch",
  "BatchableGraphics",
  "BatchableHTMLText",
  "BatchableMesh",
  "BatchableSprite",
  "BatchableText",
  "Batcher",
  "BatcherPipe",
  "BatchGeometry",
  "BatchTextureArray",
  "bgr2rgb",
  "BigPool",
  "BindGroup",
  "BindGroupSystem",
  "BitmapFont",
  "bitmapFontCachePlugin",
  "BitmapFontManager",
  "bitmapFontTextParser",
  "bitmapFontXMLParser",
  "bitmapFontXMLStringParser",
  "BitmapText",
  "BitmapTextGraphics",
  "BitmapTextPipe",
  "bitmapTextSplit",
  "BLEND_TO_NPM",
  "BlendModeFilter",
  "BlendModePipe",
  "blendTemplateFrag",
  "blendTemplateVert",
  "blendTemplateWgsl",
  "blockDataMap",
  "BlurFilter",
  "BlurFilterPass",
  "blurTemplateWgsl",
  "Bounds",
  "boundsPool",
  "BREAK_AFTER_CHARS",
  "BREAK_AFTER_CHARS_SET",
  "BREAKING_SPACES",
  "BREAKING_SPACES_SET",
  "BrowserAdapter",
  "browserExt",
  "Buffer",
  "BUFFER_TYPE",
  "BufferImageSource",
  "BufferResource",
  "BufferUsage",
  "buildAdaptiveBezier",
  "buildAdaptiveQuadratic",
  "buildArc",
  "buildArcTo",
  "buildArcToSvg",
  "buildCircle",
  "buildContextBatches",
  "buildEllipse",
  "buildGeometryFromPath",
  "buildLine",
  "buildPixelLine",
  "buildPolygon",
  "buildRectangle",
  "buildRoundedRectangle",
  "buildSimpleUvs",
  "buildSVGFillAttributes",
  "buildSVGPath",
  "buildSVGStrokeAttributes",
  "buildTriangle",
  "buildUvs",
  "Cache",
  "cacheAsTextureMixin",
  "cacheTextureArray",
  "calculatePathArea",
  "calculateProjection",
  "canUseNewCanvasBlendModes",
  "CanvasBatchAdaptor",
  "CanvasBitmapTextPipe",
  "CanvasColorMaskPipe",
  "CanvasContextSystem",
  "CanvasFilterSystem",
  "CanvasGraphicsAdaptor",
  "CanvasGraphicsContextSystem",
  "CanvasGraphicsPipe",
  "CanvasLimitsSystem",
  "CanvasNineSliceSpritePipe",
  "CanvasObserver",
  "CanvasParticleContainerAdaptor",
  "CanvasParticleContainerPipe",
  "CanvasPool",
  "CanvasPoolClass",
  "CanvasRenderer",
  "CanvasRendererTextSystem",
  "CanvasRenderTargetAdaptor",
  "CanvasRenderTargetSystem",
  "CanvasSource",
  "CanvasStencilMaskPipe",
  "CanvasTextGenerator",
  "CanvasTextMetrics",
  "CanvasTextPipe",
  "canvasTextSplit",
  "CanvasTextSystem",
  "CanvasTextureSystem",
  "CanvasTilingSpritePipe",
  "canvasUtils",
  "checkChildrenDidChange",
  "checkDataUrl",
  "checkExtension",
  "checkForNestedPattern",
  "checkMaxIfStatementsInShader",
  "childrenHelperMixin",
  "Circle",
  "cleanArray",
  "cleanHash",
  "CLEAR",
  "clearList",
  "closePointEps",
  "collapseNewlines",
  "collapseSpaces",
  "COLLAPSIBLE_SPACES",
  "COLLAPSIBLE_SPACES_SET",
  "collectAllRenderables",
  "collectRenderablesMixin",
  "Color",
  "color32BitToUniform",
  "colorBit",
  "colorBitGl",
  "ColorMask",
  "ColorMaskPipe",
  "ColorMatrixFilter",
  "colorMatrixFilterFrag",
  "colorMatrixFilterWgsl",
  "colorToUniform",
  "compareModeToGlCompare",
  "compileHighShader",
  "compileHighShaderGl",
  "compileHighShaderGlProgram",
  "compileHighShaderGpuProgram",
  "compileHooks",
  "compileInputs",
  "compileOutputs",
  "compileShader",
  "CompressedSource",
  "compute2DProjection",
  "Container",
  "convertFormatIfRequired",
  "convertToList",
  "copySearchParams",
  "createGlUploadCubeTextureResource",
  "createGpuUploadCubeTextureResource",
  "createIdFromString",
  "createIndicesForQuads",
  "createLevelBuffers",
  "createLevelBuffersFromKTX",
  "createStringVariations",
  "createTexture",
  "createUboElementsSTD40",
  "createUboElementsWGSL",
  "createUboSyncFunction",
  "createUboSyncFunctionSTD40",
  "createUboSyncFunctionWGSL",
  "crossOrigin",
  "CubeTexture",
  "CubeTextureSource",
  "Culler",
  "CullerPlugin",
  "cullingMixin",
  "curveEps",
  "CustomRenderPipe",
  "D3D10_RESOURCE_DIMENSION",
  "D3DFMT",
  "DATA_URI",
  "DDS",
  "DefaultBatcher",
  "defaultFilterVert",
  "DefaultShader",
  "defaultValue",
  "definedProps",
  "DEG_TO_RAD",
  "DEPRECATED_SCALE_MODES",
  "DEPRECATED_WRAP_MODES",
  "deprecation",
  "detectAvif",
  "detectBasis",
  "detectCompressed",
  "detectDefaults",
  "detectMp4",
  "detectOgv",
  "detectVideoAlphaMode",
  "detectWebm",
  "detectWebp",
  "determineCrossOrigin",
  "DisplacementFilter",
  "displacementFrag",
  "displacementVert",
  "displacementWgsl",
  "DOMAdapter",
  "DOMContainer",
  "DOMPipe",
  "DRAW_MODES",
  "DXGI_FORMAT",
  "DXGI_TO_TEXTURE_FORMAT",
  "DynamicBitmapFont",
  "earcut",
  "effectsMixin",
  "Ellipse",
  "ensureAttributes",
  "ensureIsBuffer",
  "ensurePrecision",
  "ensureTextOptions",
  "EventBoundary",
  "EventEmitter",
  "EventsTicker",
  "EventSystem",
  "executeInstructions",
  "extensions",
  "ExtensionType",
  "ExternalSource",
  "extractAttributesFromGlProgram",
  "extractAttributesFromGpuProgram",
  "extractFontFamilies",
  "extractStructAndGroups",
  "extractSubpaths",
  "extractSvgUrlId",
  "ExtractSystem",
  "fastCopy",
  "FederatedContainer",
  "FederatedEvent",
  "FederatedMouseEvent",
  "FederatedPointerEvent",
  "FederatedWheelEvent",
  "FillGradient",
  "FillPattern",
  "Filter",
  "FilterEffect",
  "FilterPipe",
  "FilterSystem",
  "findMixin",
  "fontStringFromTextStyle",
  "FontStylePromiseCache",
  "formatShader",
  "FOURCC_TO_TEXTURE_FORMAT",
  "fragmentGlTemplate",
  "fragmentGPUTemplate",
  "GAUSSIAN_VALUES",
  "GCManagedHash",
  "GCSystem",
  "generateArraySyncSTD40",
  "generateArraySyncWGSL",
  "generateBlurFragSource",
  "generateBlurGlProgram",
  "generateBlurProgram",
  "generateBlurVertSource",
  "generateGPULayout",
  "generateGpuLayoutGroups",
  "generateLayout",
  "generateLayoutHash",
  "generateParticleUpdateFunction",
  "generateProgram",
  "generateShaderSyncCode",
  "generateTextStyleKey",
  "generateTextureBatchBit",
  "generateTextureBatchBitGl",
  "generateTextureMatrix",
  "GenerateTextureSystem",
  "generateUniformsSync",
  "Geometry",
  "getAdjustedBlendModeBlend",
  "getAttributeInfoFromFormat",
  "getBatchSamplersUniformGroup",
  "getBitmapTextLayout",
  "getCanvasBoundingBox",
  "getCanvasFillStyle",
  "getCanvasTexture",
  "getCharacterGroups",
  "getDefaultUniformValue",
  "getFastGlobalBounds",
  "getFastGlobalBoundsMixin",
  "getFillInstructionData",
  "getFontCss",
  "getFontFamilyName",
  "getGeometryBounds",
  "getGlobalBounds",
  "getGlobalMixin",
  "getGlobalRenderableBounds",
  "getGlTypeFromFormat",
  "getLocalBounds",
  "getMaxFragmentPrecision",
  "getMaxMiterRatio",
  "getMaxTexturesPerBatch",
  "getOrientationOfPoints",
  "getPlainText",
  "getPo2TextureFromSource",
  "getResolutionOfUrl",
  "getSupportedCompressedTextureFormats",
  "getSupportedGlCompressedTextureFormats",
  "getSupportedGPUCompressedTextureFormats",
  "getSupportedTextureFormats",
  "getSVGUrl",
  "getTemporaryCanvasFromImage",
  "getTestContext",
  "getTextureBatchBindGroup",
  "getTextureDefaultMatrix",
  "getTextureFormatFromKTXTexture",
  "getUboData",
  "getUniformData",
  "getUrlExtension",
  "GL_FORMATS",
  "GL_INTERNAL_FORMAT",
  "GL_TARGETS",
  "GL_TYPES",
  "GL_WRAP_MODES",
  "GlBackBufferSystem",
  "GlBatchAdaptor",
  "GlBuffer",
  "GlBufferSystem",
  "GlColorMaskSystem",
  "GlContextSystem",
  "GlEncoderSystem",
  "glFormatToGPUFormat",
  "GlGeometryGpuData",
  "GlGeometrySystem",
  "GlGraphicsAdaptor",
  "GlLimitsSystem",
  "GlMeshAdaptor",
  "GlobalResourceRegistry",
  "globalUniformsBit",
  "globalUniformsBitGl",
  "globalUniformsUBOBitGl",
  "GlobalUniformSystem",
  "GlParticleContainerAdaptor",
  "GlParticleContainerPipe",
  "GlProgram",
  "GlProgramData",
  "GlRenderTarget",
  "GlRenderTargetAdaptor",
  "GlRenderTargetSystem",
  "GlShaderSystem",
  "GlStateSystem",
  "GlStencilSystem",
  "GlTexture",
  "GlTextureSystem",
  "GlUboSystem",
  "GlUniformGroupSystem",
  "glUploadBufferImageResource",
  "glUploadCompressedTextureResource",
  "glUploadImageResource",
  "glUploadVideoResource",
  "GpuBatchAdaptor",
  "GpuBlendModesToPixi",
  "GpuBufferData",
  "GpuBufferSystem",
  "GpuColorMaskSystem",
  "GpuDeviceSystem",
  "GpuEncoderSystem",
  "gpuFormatToBasisTranscoderFormat",
  "gpuFormatToKTXBasisTranscoderFormat",
  "GpuGraphicsAdaptor",
  "GpuGraphicsContext",
  "GpuLimitsSystem",
  "GpuMeshAdapter",
  "GpuMipmapGenerator",
  "GpuParticleContainerAdaptor",
  "GpuParticleContainerPipe",
  "GpuProgram",
  "GpuRenderTarget",
  "GpuRenderTargetAdaptor",
  "GpuRenderTargetSystem",
  "GpuShaderSystem",
  "GpuStateSystem",
  "GpuStencilModesToPixi",
  "GpuStencilSystem",
  "GPUTextureGpuData",
  "GpuTextureSystem",
  "GpuUboSystem",
  "GpuUniformBatchPipe",
  "gpuUploadBufferImageResource",
  "gpuUploadCompressedTextureResource",
  "gpuUploadImageResource",
  "gpuUploadVideoResource",
  "Graphics",
  "GraphicsContext",
  "GraphicsContextRenderData",
  "GraphicsContextSystem",
  "graphicsContextToSvg",
  "GraphicsGpuData",
  "GraphicsPath",
  "GraphicsPipe",
  "groupD8",
  "hasCachedCanvasTexture",
  "hasTagMarkup",
  "hasTagStyles",
  "HelloSystem",
  "hslgl",
  "hslgpu",
  "hslWgsl",
  "HTMLText",
  "HTMLTextPipe",
  "HTMLTextRenderData",
  "HTMLTextStyle",
  "HTMLTextSystem",
  "IGLUniformData",
  "ImageSource",
  "injectBits",
  "insertVersion",
  "InstructionSet",
  "isBreakAfterChar",
  "isBreakingSpace",
  "isCanvasFilterCapable",
  "isCollapsibleSpace",
  "isMobile",
  "isNewline",
  "isPow2",
  "isRenderingToScreen",
  "isSafari",
  "isSingleItem",
  "isWebGLSupported",
  "isWebGPUSupported",
  "KTX",
  "ktxTranscoderUrls",
  "loadBasis",
  "loadBasisOnWorker",
  "loadBitmapFont",
  "loadDDS",
  "loadEnvironmentExtensions",
  "Loader",
  "LoaderParserPriority",
  "loadFontAsBase64",
  "loadFontCSS",
  "loadImageBitmap",
  "loadJson",
  "loadKTX",
  "loadKTX2",
  "loadKTX2onWorker",
  "loadSvg",
  "loadSVGImage",
  "loadTextures",
  "loadTxt",
  "loadVideoTextures",
  "loadWebFont",
  "localUniformBit",
  "localUniformBitGl",
  "localUniformBitGroup2",
  "localUniformMSDFBit",
  "localUniformMSDFBitGl",
  "log2",
  "logDebugTexture",
  "logProgramError",
  "logRenderGroupScene",
  "logScene",
  "mapCanvasBlendModesToPixi",
  "mapFormatToGlFormat",
  "mapFormatToGlInternalFormat",
  "mapFormatToGlType",
  "mapGlToVertexFormat",
  "mapSize",
  "mapType",
  "mapViewDimensionToGlTarget",
  "mapWebGLBlendModesToPixi",
  "MaskEffectManager",
  "MaskEffectManagerClass",
  "MaskFilter",
  "maskFrag",
  "maskVert",
  "maskWgsl",
  "Matrix",
  "matrixPool",
  "measureHtmlText",
  "measureMixin",
  "measureTaggedText",
  "Mesh",
  "MeshGeometry",
  "MeshGpuData",
  "MeshPipe",
  "MeshPlane",
  "MeshRope",
  "MeshSimple",
  "migrateFragmentFromV7toV8",
  "mipmapScaleModeToGlFilter",
  "mSDFBit",
  "mSDFBitGl",
  "multiplyColors",
  "multiplyHexColors",
  "NEWLINE_MATCH_REGEX",
  "NEWLINE_SPLIT_REGEX",
  "NEWLINES",
  "NEWLINES_SET",
  "nextPow2",
  "NineSliceGeometry",
  "NineSlicePlane",
  "NineSliceSprite",
  "NineSliceSpriteGpuData",
  "NineSliceSpritePipe",
  "NoiseFilter",
  "noiseFrag",
  "noiseWgsl",
  "nonCompressedFormats",
  "NOOP",
  "normalizeExtensionPriority",
  "ObservablePoint",
  "onRenderMixin",
  "parseDDS",
  "parseFunctionBody",
  "parseKTX",
  "parseSVGDefinitions",
  "parseSVGFloatAttribute",
  "parseSVGPath",
  "parseSVGStyle",
  "parseTaggedText",
  "Particle",
  "ParticleBuffer",
  "ParticleContainer",
  "ParticleContainerPipe",
  "particleData",
  "particlesFrag",
  "ParticleShader",
  "particlesVert",
  "particlesWgsl",
  "PassthroughFilter",
  "passthroughFrag",
  "passthroughWgsl",
  "path",
  "PerspectiveMesh",
  "PerspectivePlaneGeometry",
  "PI_2",
  "PipelineSystem",
  "PlaneGeometry",
  "Point",
  "pointInTriangle",
  "Polygon",
  "Pool",
  "PoolGroupClass",
  "preloadVideo",
  "PrepareBase",
  "PrepareQueue",
  "PrepareSystem",
  "PrepareUpload",
  "QuadGeometry",
  "RAD_TO_DEG",
  "Rectangle",
  "removeItems",
  "removeStructAndGroupDuplicates",
  "RenderableGCSystem",
  "RenderContainer",
  "RendererInitHook",
  "RendererType",
  "RenderGroup",
  "RenderGroupPipe",
  "RenderGroupSystem",
  "RenderLayer",
  "RenderTarget",
  "RenderTargetSystem",
  "RenderTexture",
  "resetUids",
  "ResizePlugin",
  "resolveCharacters",
  "resolveCompressedTextureUrl",
  "resolveJsonUrl",
  "Resolver",
  "resolveTextureUrl",
  "resourceToTexture",
  "RopeGeometry",
  "RoundedRectangle",
  "roundedShapeArc",
  "roundedShapeQuadraticCurve",
  "roundPixelsBit",
  "roundPixelsBitGl",
  "sayHello",
  "SCALE_MODES",
  "scaleModeToGlFilter",
  "SchedulerSystem",
  "ScissorMask",
  "SdfShader",
  "setBasisTranscoderPath",
  "setKTXTranscoderPath",
  "setPositions",
  "setProgramName",
  "setUvs",
  "Shader",
  "ShaderStage",
  "shapeBuilders",
  "ShapePath",
  "SharedRenderPipes",
  "SharedSystems",
  "sortMixin",
  "SplitBitmapText",
  "SplitText",
  "Sprite",
  "SpritePipe",
  "Spritesheet",
  "spritesheetAsset",
  "squaredDistanceToLineSegment",
  "State",
  "STENCIL_MODES",
  "StencilMask",
  "StencilMaskPipe",
  "stripVersion",
  "styleAttributes",
  "SVGDefsCollector",
  "SVGParser",
  "SystemRunner",
  "testImageFormat",
  "testVideoFormat",
  "Text",
  "TextStyle",
  "textStyleToCSS",
  "Texture",
  "TEXTURE_FORMAT_BLOCK_SIZE",
  "textureBit",
  "textureBitGl",
  "textureFrom",
  "TextureGCSystem",
  "TextureMatrix",
  "TexturePool",
  "TexturePoolClass",
  "TextureSource",
  "TextureStyle",
  "TextureUvs",
  "Ticker",
  "TickerListener",
  "TickerPlugin",
  "tilingBit",
  "tilingBitGl",
  "TilingSprite",
  "TilingSpriteGpuData",
  "TilingSpritePipe",
  "TilingSpriteShader",
  "toFillStyle",
  "tokenize",
  "tokenizeTaggedRuns",
  "toLocalGlobalMixin",
  "toStrokeStyle",
  "Transform",
  "transformVertices",
  "Triangle",
  "triangulateWithHoles",
  "trimRight",
  "UboBatch",
  "uboSyncFunctionsSTD40",
  "uboSyncFunctionsWGSL",
  "UboSystem",
  "uid",
  "UNIFORM_TO_ARRAY_SETTERS",
  "UNIFORM_TO_SINGLE_SETTERS",
  "UNIFORM_TYPES_MAP",
  "UNIFORM_TYPES_VALUES",
  "UniformGroup",
  "uniformParsers",
  "unpremultiplyAlpha",
  "unsafeEvalSupported",
  "UPDATE_BLEND",
  "UPDATE_COLOR",
  "UPDATE_PRIORITY",
  "UPDATE_TRANSFORM",
  "UPDATE_VISIBLE",
  "updateLocalTransform",
  "updateQuadBounds",
  "updateRenderGroupTransform",
  "updateRenderGroupTransforms",
  "updateTextBounds",
  "updateTransformAndChildren",
  "updateTransformBackwards",
  "updateWorldTransform",
  "v8_0_0",
  "v8_3_4",
  "validateRenderables",
  "validFormats",
  "VERSION",
  "vertexGlTemplate",
  "vertexGPUTemplate",
  "VideoSource",
  "ViewableBuffer",
  "ViewContainer",
  "ViewSystem",
  "vkFormatToGPUFormat",
  "warn",
  "WebGLRenderer",
  "WebGPURenderer",
  "WGSL_ALIGN_SIZE_DATA",
  "WGSL_TO_STD40_SIZE",
  "wordWrap",
  "wordWrapTaggedLines",
  "WorkerManager",
  "WRAP_MODES",
  "wrapModeToGlAddress"
] as const;
